<template>
<d-container fluid class="main-content-container h-100 px-4 container-fluid">
   <div class="row h-100 no-gutters">
      <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
         <div class="card">
            <div class="card-body">
               <img src="@/assets/images/shards-dashboards-logo.svg" alt="Shards Dashboards - Forgot Password Template" class="auth-form__logo d-table mx-auto mb-3">
               <h5 class="auth-form__title text-center mb-4">Reset Password</h5>
               <form class="">
                  <div class="form-group mb-4">
                      <label for="exampleInputEmail1">Email address</label>
                      <d-input-group class="mb-2">
                          <d-input v-model="email" type="email" placeholder="Enter email"/>
                          <d-input-group-addon append>
                              <d-btn theme="secondary" @click.prevent="sendCode(), counter += 1">Send code</d-btn>
                          </d-input-group-addon>
                      </d-input-group>
                      <label for="exampleInputCode">Password reset code</label>
                      <input id="exampleInputCode" v-model="otp" type="text" placeholder="000000" class="form-control">                      
                      <small class="text-muted text-center form-text text-secondary">You will receive an email with a unique token.</small></div>
                  <button type="submit" @click.prevent="forgotPassword()" class="btn btn-pill btn-accent d-table mx-auto">Reset Password</button>
               </form>
            </div>
         </div>
         <div class="auth-form__meta d-flex mt-4"><router-link :to="{ path: '/' }">Take me back to login.</router-link></div>
      </div>
   </div>
  </d-container>
</template>

<script>
import axios from "axios";

export default {
  name: 'forgot-password',
  data() {
    return {
      email: "",
      otp: "",
      counter: 0
    };
  },
  methods: {
    sendCode() {
    axios
      .post(
        "https://wepark-authorization.ive.appliedtech.ltd/api/auth/User/reset-password/send-code",{
          email: this.email
        })
      .then((response) => {
      });
    },
    forgotPassword() {
      axios
        .post('https://wepark-authorization.ive.appliedtech.ltd/api/auth/User/reset-password/verify-code', {
          otp: this.otp,
          counter: this.counter,
          email: this.email
        })
        .then(response => {
          if (response.data.result == true) {
            this.$router.push({
              name: "new-password",
              params: { otp: this.otp, email: this.email},
            });
          }
        })
        .catch(err => {
          alert(err);
        });
    },
  },
};
</script>